import React, { useEffect, useState } from "react";
import {
  countries,
  countries_en,
} from "../../../../../utils/constants/nameCountry";
import { useCurrentLanguage } from "../../../../../hooks/useCurrentLanguage";
import { getSurveyJSON } from "../../../../../services/jsons";
import { TOOLTIP_STYLE } from "../../../../../utils/constants/graphConfigs";
import CardSurveys from "../../../../reusable/CardSurveys";

export default function IplDiscrimination() {
  const { language } = useCurrentLanguage();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState();

  // Transform data to fit the line chart structure
  function transformData(data) {
    const countriesList = data.countries;
    const categories = data.categories;
    const values = data.values;

    const series = countriesList.map((countryCode) => ({
      name: language === "en" ? countries_en[countryCode] : countries[countryCode],
      type: "line",
      data: values[countryCode],
      smooth: true, // Optional: for a smooth line
    }));

    return { categories, series };
  }

  // Load graph data
  useEffect(() => {
    const getData = async () => {
      const response = await getSurveyJSON("ipl_discrimination");
      setData(response);
      setIsLoading(false);
    };

    getData();
  }, []);

  useEffect(() => {
    if (!isLoading && data !== undefined) {
      const { categories, series } = transformData(data);
      const options = {
        textStyle: {
          fontFamily: "Open Sans",
        },
        color: ["#305EA9", "#6CCDEF", "#8DBA38", "#F4DB4E"],
        tooltip: {
          trigger: "axis",
          ...TOOLTIP_STYLE,
          valueFormatter: (value) => value.toFixed(1) + "%",
          axisPointer: {
            type: "cross",
          },
          formatter: (props) => {
            const divs = [];

            divs.push("<span>" + props[0].axisValue + "</span></br>");
            props.forEach((line) => {
              divs.push(
                "<div>" +
                  line.marker +
                  " " +
                  line.seriesName +
                  ": " +
                  line.data.toFixed(2) +
                  "%</div>"
              );
            });
            return divs.join("");
          },
        },
        legend: {
          top: "2%",
          left: "10%",
          type: "scroll",
          data: series.map((s) => s.name),
        },
        grid: {
          top: "9%",
          left: "6%",
          right: "4%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: categories,
          name: "Puntaje (Más integración ->)",
          nameLocation: "middle",
          nameGap: 30,
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: 14,
          },
        },
        yAxis: {
          type: "value",
          name: "Porcentaje encuestados (%)",
          nameLocation: "middle",
          nameRotate: 90,
          nameGap: 34,
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: 14,
          },
        },
        series: series,
      };
      setOptions(options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return (
    <CardSurveys
      isLoading={isLoading}
      options={options}
      graphTitle={data ? data.question[language] : null}
    />
  );
}